/**
 * The constants module is for storing all SILA constants
 *
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
import Vue from 'vue'
import api from '@/api'
import {
    VUEX_CONSTANTS_INIT,
    VUEX_CONSTANTS_INITIALIZED,
    VUEX_CONSTANTS_SET_ALL,
    } from '@/store/constants/config/constants' // <- that's confusing :-)


/**
 * Constants module state
 * @const
 */
const state = {
	initialized: false
}

/**
 * Constants module getters
 * @const
 */
const getters = {
    constantsAreLoaded: state => state.initialized,

    getConst: (state) => (constToFind) => {
        return state[constToFind]
    },
}

/**
 * Constants module action definitions
 * @const
 */
const actions = {
    [VUEX_CONSTANTS_INIT]: async ({ commit }) => {
        commit(VUEX_CONSTANTS_INIT)

        await api.get('/config/constants').then((response) => {
          commit(VUEX_CONSTANTS_SET_ALL, response.data.data)
        })

        commit(VUEX_CONSTANTS_INITIALIZED)
    },
}

/**
 * Constants module mutation definitions
 * @const
 */
const mutations = {
	[VUEX_CONSTANTS_INIT]: () => {},

	[VUEX_CONSTANTS_INITIALIZED]: (state) => {
		state.initialized = true
	},

    [VUEX_CONSTANTS_SET_ALL]: (state, payload) => {
		Object.keys(payload).forEach( function(constant, index) {
			Vue.set(state, constant, payload[constant])

			/*jslint browser: true */
			window[constant] = payload[constant]
		})
    }
}


/**
 * The Constants module of our Vuex store.
 * @module store/modules/constants
 */
export default {
  state,
  getters,
  actions,
  mutations,
}
